import { Template } from '../domain/entities/Template'
import { TemplateRule } from '../domain/entities/TemplateRule'
import { ITemplateRepository } from '../domain/repositories/ITemplateRepository'

export class SaveTemplateUseCase {
  constructor(private readonly repository: ITemplateRepository) {}

  execute(template: Template): Promise<Template> {
    const payload: Template = {
      ...template,
      rules: template.rules.map((rule): TemplateRule =>
        rule.provider
          ? rule
          : { ...rule, provider: null, providerService: null },
      ),
    }

    return this.repository.saveTemplate(payload)
  }
}
